// ATTRIB constants for data-testid attributes
export const ATTRIB = {
  TEST: {
    SELECT_LANGUAGE: 'select-language',
    SELECT_THEME: 'select-theme',
    SEARCH_TODOS_INPUT: 'search-todos-input',
    HOME: 'open-home',
    PROFILE: 'open-profile',
    TEAM: 'open-team',
    CLASSES: 'open-classes',
    ACCOUNTABILITY_BUDDY: 'open-accountability-buddy',
    MANAGE_SUBSCRIPTION: 'manage-subscription',
    CHAT: 'open-chat',
    SETTINGS: 'open-settings',
    ADMIN: 'open-admin',
    STORE: 'open-store',
    ACTIVITY_LIBRARY: 'open-activity-library',
    MARKETPLACE: 'open-marketplace',
    INTEGRATIONS: 'integrations',
    DOWNLOAD_APPS: 'open-download-apps',
    PRIVACY_SECURITY: 'open-privacy-security',
    LOGOUT: 'open-logout',
    OPEN_SIDE_NAVBAR: 'open-side-navbar',
    CLOSE_SIDE_NAVBAR: 'close-side-navbar',
    SAVE_MORE_OPTIONS: 'save-more-options',
    CANCEL_MORE_OPTIONS: 'cancel-more-options',
    MANAGE_YOUTUBE_URLS: 'manage-youtube-urls',
    ADD_YOUTUBE_URL: 'add-youtube-url',
    SAVE_YOUTUBE_URLS: 'save-youtube-urls',
    ADD_ALLOWED_URL: 'add-allowed-url',
    SAVE_ALLOWED_URLS: 'save-allowed-urls',
    INPUT_YOUTUBE_URL: 'input-youtube-url',
    INPUT_ALLOWED_URL: 'input-allowed-url',
    INPUT_APPLICATIONS: 'input-applications',
    SWITCH_USE_APPS: 'switch-use-apps',
    SWITCH_USE_WEBSITES: 'switch-use-websites',
    SWITCH_USE_FOCUS_MODES: 'switch-use-focus-modes',
    SELECT_LOG_SUMMARY: 'select-log-summary',
    INPUT_LOG_SUMMARY: 'input-log-summary',
    SELECT_TAKE_NOTE: 'select-take-notes',
    INPUT_TAKE_NOTE: 'input-take-notes',
    SWITCH_LOG_QUANTITY: 'switch-log-quantity',
    SELECT_ACTIVITY_CHOICE: 'select-activity-choice',
    INPUT_ACTIVITY_CHOICE: 'input-activity-choice',
    EDIT_ACTIVITY_CHOICE: 'edit-activity-choice',
    NEW_ACTIVITY_CHOICE: 'new-activity-choice',
    SAVE_ACTIVITY_CHOICES: 'save-activity-choices',
    INPUT_ACTIVITY_CHOICE_NAME: 'input-activity-choice-name',
    INPUT_AUTO_SUGGESTION_ACTIVITY_CHOICE_NAME:
      'input-auto_suggestion-activity-choice-name',
    INPUT_AUTO_SUGGESTION_ACTIVITY_CHOICE_EMOJI:
      'input-auto_suggestion-activity-choice-emoji',
    INPUT_AUTO_SUGGESTION_ACTIVITY_NAME: 'input-auto_suggestion_activity-name',
    INPUT_AUTO_SUGGESTION_ACTIVITY_EMOJI:
      'input-auto_suggestion_activity-emoji',
    OPEN_CHOICE_YOUTUBE_VIDEOS: 'open-choice-youtube-videos',
    SWITCH_CHOICE_USE_TIMER: 'switch-choice-use-timer',
    INPUT_CHOICE_COMPLETION_REQUIREMENT: 'input-choice-completion-requirement',
    TAB_TIMING: 'tab_timing',
    TAB_YOUTUBE_VIDEOS: 'tab_youtube_videos',
    TAB_OTHER_APPS: 'tab_other_apps',
    TAB_LOG_DATA: 'tab_log_data',
    COURSE_LESSON_ITEM: 'course-lesson-item',
    LESSON_TITLE: 'lesson-title',
    LESSON_PROGRESS: 'lesson-progress',
    COURSE_SLIDER_WRAPPER: 'course-slider-wrapper',
    COURSE_SLIDE: 'course-slide',
    COURSE_SUMMARY: 'course-summary',
    COURSE_COMPLETION_TEXT: 'completion-text',
    COURSE_LOADING_SPINNER: 'course-loading-spinner',
    START_LESSON_BUTTON: 'start-lesson-button',
    RICH_TEXT_EDITOR: 'rich-text-editor',
    LOADING_SCREEN_WRAPPER: 'loading-screen-wrapper',

    TAB_SETTINGS: 'tab_settings',
    TAB_INSTRUCTIONS: 'tab_instructions',
    TAB_ADVANCED: 'tab_advanced',
    HEADERS: {
      DEFAULT: [
        'header_timing',
        'header_morning_routine',
        'header_micro_breaks',
        'header_evening_routine',
        'header_habit_packs'
      ],
      FOCUS_MODE: [],
      STANDALONE: ['header_activities', 'header_pack_info'],
      ROUTINE: [
        'header_morning_routine',
        'header_micro_breaks',
        'header_evening_routine',
        'header_pack_info'
      ],
      FREESTYLE: ['header_timing', 'header_micro_breaks']
    },
    ADD_LOG_QUANTITY_QUESTION: 'add-log-quantity-question',
    MORE_OPTION_INPUT_LOG_QUESTION: 'more-option-input-log-question',
    CHOICES_INPUT_LOG_QUESTION: 'choices-input-log-question',
    SWITCH_INCLUDE_IN_EVERY_BREAK: 'switch_include_in_every_break',
    INPUT_COMPLETION_REQUIREMENTS: 'input-completion-requirements',
    SWITCH_USE_TIMER: 'switch-use-timer',
    CLOSE_MODAL: 'close-modal',
    INPUT_LOG_QUESTION_DETAILS_MINIMUM: 'input-log-question-details-minimum',
    INPUT_LOG_QUESTION_DETAILS_MINIMUM_DESCRIPTION:
      'input-log-question-details-minimum-description',
    INPUT_LOG_QUESTION_DETAILS_MAXIMUM: 'input-log-question-details-maximum',
    INPUT_LOG_QUESTION_DETAILS_MAXIMUM_DESCRIPTION:
      'input-log-question-details-maximum-description',
    ADD_CHECK_LIST: 'add-check-list',
    SAVE_CHECK_LISTS: 'save-check-lists',
    PERSONAL_SUBSCRIPTION: 'personal-subscription',
    BUSINESS_SUBSCRIPTION: 'business-subscription',
    SAVE_LOG_QUESTION_DETAILS: 'save-log-question-details',
    ROUTINE_PLAYER: {
      ACTIVITY_SUMMARY_HABIT_NAME: 'activity-summary-habit-name'
    },
    INPUT_MOTIVATIONAL_STYLE: 'input-motivational-style',
    SELECT_MOTIVATIONAL_STYLE: 'select-motivational-style',
    INPUT_REQUEST_HABIT_DATA: 'input-request-habit-data',
    SELECT_REQUEST_HABIT_DATA_STYLE: 'select-request-habit-data-style',
    CURRENT_PLAYING_ACTIVITY_TITLE: 'current-playing-activity-title',
    LOGIN: 'login',
    AGREE: 'agree',
    SIGN_UP: 'sign-up',
    SIGN_IN: 'sign-in',
    SIGN_UP_WITH_EMAIL: 'sign-up-with-email',
    SIGN_UP_SUBMIT: 'sign-up-submit',
    FORGOT_PASSWORD_RESET_SUBMIT: 'forgot-password-reset-submit',
    RESET_PASSWORD_CHANGE_PASSWORD_SUBMIT:
      'reset-password-change-password-submit',
    INPUT_EMAIL_SIGN_UP: 'input-email-sign-up',
    INPUT_PASSWORD_SIGN_UP: 'input-password-sign-up',
    INPUT_EMAIL_SIGN_IN: 'input-email-sign-in',
    INPUT_EMAIL_RESET_PASSWORD: 'input-email-reset-password',
    INPUT_EMAIL_FORGOT_PASSWORD: 'input-email-forgot-password',
    INPUT_PASSWORD_SIGN_IN: 'input-password-sign-in',
    ONBOARD_CONTINUE_BTN: 'onboard-continue-btn',
    ONBOARD_YES_BTN: 'onboard-yes-btn',
    ONBOARD_FEATURE: (feature: string) => `onboard-feature-${feature}`,
    ONBOARD_COACHING_NO_THANKS_BTN: 'onboard-coaching-no-thanks-btn',
    ONBOARD_DOWNLOAD_BTN: (platform: string) =>
      `onboard-download-${platform.toLowerCase()}-btn`,
    ONBOARD_GO_TO_DASHBOARD_BTN: 'onboard-go-to-dashboard-btn',
    ONBOARD_STEP: (step: number) => `onboard-step-${step}`,
    PRIVACY_CONSENT_CHECKBOX: 'privacy-consent-checkbox',
    BUTTON_BACK_TO_DASHBOARD: 'button-back-to-dashboard',
    BUTTON_BACK_TO_HABIT_PACK: 'button-back-to-habit-pack',
    BUTTON_BEGIN_ROUTINE: 'button-begin-routine',
    BUTTON_SKIP_ACTIVITY: 'button-skip-activity',
    COUNT_DOWN_CLOCK: 'count-down-clock',
    IFRAME_YOUTUBE_PLAYER: 'iframe-youtube-player',
    TODO: 'to-do',
    DAY_PLAN: 'day-plan',
    ICON_ADD_HABIT: 'icon-add-habit',
    INPUT_HABIT_DURATION_MINUTE: 'input-habit-duration-minute',
    INPUT_HABIT_DURATION_SECOND: 'input-habit-duration-second',
    BUTTON_MORE_OPTION: 'button-more-option',
    BUTTON_DELETE_ACTIVITY: 'button-delete-activity',
    INPUT_HABIT_NAME: 'input-habit-name',
    BUTTON_SAVE_SETTINGS: 'button-save-settings',
    SORT_MODE_CHRONO: 'sort-mode-chrono',
    SORT_MODE_SMART: 'sort-mode-smart',
    SORT_MODE_DUE_DATE: 'sort-mode-due-date',
    ACTION_SPARKLES: 'action-sparkles',
    ACTION_NEW_TASK: 'action-new-task',
    ACTION_FILTER: 'action-filter',
    ACTION_DELETE_SELECTED: 'action-delete-selected',
    ACTION_MORE_MOBILE: 'action-more-mobile',
    ACTION_MORE_TOOLS: 'action-more-tools',
    ACTION_BRAIN_DUMP: 'action-brain-dump',
    ACTION_EXPORT_CSV: 'action-export-csv',
    ACTION_EISENHOWER_MATRIX: 'action-eisenhower-matrix',
    ACTION_PROCRASTINATE: 'action-procrastinate',
    FOCUS_SUMMARY_ADD_MANUAL_BTN: 'focus-summary-add-manual-btn',
    FOCUS_SUMMARY_REFRESH_BTN: 'focus-summary-refresh-btn',
    FOCUS_SUMMARY_GRAPH_BTN: 'focus-summary-graph-btn',
    FOCUS_SUMMARY_EXPORT_BTN: 'focus-summary-export-btn',
    PROJECTS: 'projects'
  },
  LOCATOR: {
    ADD_HABIT: 'add-habit',
    HABIT_DURATION_MINUTE: 'habit-duration-minute',
    HABIT_DURATION_SECOND: 'habit-duration-second',
    MORE_OPTION: 'more-option',
    DELETE_ACTIVITY: 'delete-activity',
    HABIT_NAME: 'habit-name',
    HABIT_EMOJI: 'habit-emoji',
    USE_TIMER: 'use-timer'
  },
  DATA_TESTID: {
    SAVE_LONG_TERM_GOALS_BTN: 'save-long-term-goals-btn',
    ADD_GOAL_BTN: 'add-goal-btn',
    REMOVE_GOAL_BTN: (position: number) => `remove-goal-btn-${position}`,
    REQUEST_DATA_BTN: 'request-data-btn',
    DELETE_ACCOUNT_BTN: 'delete-account-btn',
    CONFIRM_USER_ACTION_BTN: 'confirm-user-action-btn',
    UPDATE_PROFILE_PICTURE_BTN: 'update-profile-picture-btn',
    REMOVE_PROFILE_PICTURE_BTN: 'remove-profile-picture-btn',
    CATEGORY_SELECTOR_BTN: (type: string) =>
      `category-selector-btn-${type.toLowerCase()}`,
    ROUTINE_ANALYZER_NEXT_BTN: 'routine-analyzer-next-btn',
    CLIENT_MESSAGE_MODAL: 'client-message-modal',
    EMAIL_VERIFICATION_BANNER: 'email-verification-banner',
    OVERLAY_SPINNER: 'overlay-spinner',
    UNLOCK_HABIT_PACK_MODAL: 'unlock-habit-pack-modal',
    USER_PRIVACY_MODAL: 'user-privacy-modal',
    HABIT_PACK_CARD: 'habit-pack-card',
    ENROLLED_COURSE_DETAILS_MODAL_WRAPPER:
      'enrolled-course-details-modal-wrapper',
    LOGOUT_BUTTON: 'logout-button',
    SUMMARY_BTN_DAILY: 'summary-btn-daily',
    SUMMARY_BTN_MONTHLY: 'summary-btn-monthly',
    SUMMARY_BTN_YEARLY: 'summary-btn-yearly',
    TUTORIAL_DROPDOWN: 'tutorial-dropdown',
    FEEDBACK_TEXTAREA: 'feedback-textarea',
    SUBMIT_FEEDBACK_BTN: 'submit-feedback-btn',
    SUBSCRIPTION_CANCEL_RENEW_BTN: 'subscription-cancel-renew-btn',
    CHANGE_PAYMENT_METHOD_BTN: 'change-payment-method-btn',
    DOWNLOAD_LINK_MAC: 'download-link-mac',
    DOWNLOAD_LINK_WINDOWS: 'download-link-windows',
    DOWNLOAD_LINK_IOS: 'download-link-ios',
    DOWNLOAD_LINK_ANDROID: 'download-link-android',
    HABIT_PACK_ACTION_EDIT: 'habit-pack-action-edit',
    HABIT_PACK_ACTION_DELETE: 'habit-pack-action-delete',
    HABIT_PACK_ACTION_DUPLICATE: 'habit-pack-action-duplicate',
    HABIT_PACK_ACTION_GENERATE_PDF: 'habit-pack-action-generate_pdf',
    HABIT_PACK_ACTION_PLAY: 'habit-pack-action-play',
    HABIT_PACK_ACTION_BACK: 'habit-pack-action-back',
    HABIT_PACK_ACTION_UNINSTALL: 'habit-pack-action-uninstall',
    HABIT_PACK_ACTION_INSTALL: 'habit-pack-action-install',
    FOCUS_TEMPLATE_ACTION_BACK: 'focus-template-action-back',
    FOCUS_TEMPLATE_ACTION_UNINSTALL: 'focus-template-action-uninstall',
    FOCUS_TEMPLATE_ACTION_EDIT: 'focus-template-action-edit',
    FOCUS_TEMPLATE_ACTION_DELETE: 'focus-template-action-delete',
    SHARE_PACK_CONTAINER: 'share-pack-container',
    FOCUS_TEMPLATE_CARD: 'focus-template-card',
    LOADING_SCREEN: 'loading-screen',
    PAGINATION_BTN_LABEL: (label: string) => `pagination-btn-${label}`,
    RICH_TEXT_EDITOR: 'rich-text-editor',
    SKELETON_LOADER: 'skeleton-loader',
    SPINNER_LOADER: 'spinner-loader',
    STAR_BUTTON_POSITION: (position: number) => `star-button-${position}`,
    TOOLTIP_ICON: 'tooltip-icon',
    MARKETPLACE_ACTION_BUTTON: 'marketplace-action-button',
    COPY_LINK_BUTTON: 'copy-link-button',
    TEXT_INPUT: 'text-input',
    COURSE_REVIEW_RATE: (rate_id: string) => `course-review-${rate_id}`,
    COURSE_LESSON_ITEM: 'course-lesson-item',
    COURSE_LESSON_TITLE: 'course-lesson-title',
    COURSE_SUMMARY: 'course-summary',
    UPLOAD_FILE_BUTTON: 'upload-file-button',
    CLOSE_SURVEY_BTN: 'close-survey-btn',
    ACTIVITY_ICON_VIDEO: 'activity-icon-video',
    ACTIVITY_ICON_LOG: 'activity-icon-log',
    ACTIVITY_ICON_ALLOWED: 'activity-icon-allowed',
    ACTIVITY_ICON_CHOICE: 'activity-icon-choice',
    FOOTER_TERMS_LINK: 'footer-terms-link',
    FOOTER_PRIVACY_LINK: 'footer-privacy-link',
    FOOTER_LOGO: 'footer-logo',
    FOOTER_WEBSITE_LINK: 'footer-website-link',
    MORNING_ROUTINE_ROUTINE_REMINDER_BTN: 'morning-routine-reminder-btn',
    EVENING_ROUTINE_ROUTINE_REMINDER_BTN: 'evening-routine-reminder-btn',
    EXIT_INQUIRY_MODAL_BTN: 'exit-inquiry-modal-btn',
    LANDING_HEADING: 'landing-heading',
    LADING_AUTHOR: 'landing-author',
    WELCOME_VIDEO_IFRAME: 'welcome-video-iframe',
    WELCOME_HEADER: 'welcome-header',
    NAV_MENU_MAIN_BTN: 'nav_menu-main-btn',
    OPEN_INQUIRY_MODAL_BTN: 'open-inquiry-modal-btn',
    LOG_QUANTITY_SAVE_BTN: 'log-quantity-save-btn',
    LOG_QUESTION_RANGE_INDX: (index: number) => `log-question-range-${index}`,
    NOTE_SAVE_BTN: 'note-save-btn',
    HABIT_PACK_DROPDOWN: 'habit-pack-dropdown',
    INSTALL_HABIT_PACK_BTN: 'install-habit-pack-btn',
    UPDATE_GOAL_LIST_BTN: 'update-goal-list-btn',
    EDIT_HABITS_BTN: 'edit-habits-btn',
    ENABLE_EDIT_HABITS_WRAPPER: 'enable-edit-habits-wrapper',
    ACTIVITY_SUGGESTION_WRAPPER: 'activity-suggestion-wrapper',
    HABIT_PACK_LIST_SECTION: 'habit-pack-list-section',
    SWITCH_WITH_LABEL: 'switch-with-label',
    SETTINGS_TABS_CONTAINER: 'settings-tabs-container',
    REFRESH_FAB: 'refresh-fab',
    TEXTAREA_WITH_LABEL: 'textarea-with-label',
    CHOICE_ITEM_WRAPPER: 'choice-item-wrapper',
    CHOICES_MODAL_WRAPPER: 'choices-modal-wrapper',
    MORE_OPTIONS_WRAPPER: 'more-options-wrapper',
    TAGS_CONTAINER: 'tags-container',
    TAG_INPUT: 'tag-input',
    MOVE_TO_DIFFERENT_ROUTINE: 'move-to-different-routine',
    MICRO_BREAK_SWITCH: 'micro-break-switch',
    TEXT_INSTRUCTIONS: 'text-instructions',
    LOG_SUMMARY_WRAPPER: 'log-summary-wrapper',
    IS_OFFICE_FRIENDLY: 'is-office-friendly',
    CHECKLIST_INPUT: (position: number) => `checklist-input-${position}`,
    PACK_DETAILS_LIST_WRAPPER: 'pack-details-list-wrapper',
    SELECT_MEMBER_CHECKBOX: 'select-member-checkbox',
    COLLAPSE_TASK_BTN: 'collapse-task-btn',
    VIEW_SUBTASKS_BTN: 'view-subtasks-btn',
    CREATE_FREE_TIME_HABIT_BTN: 'create-free-time-habit-btn',
    TIME_PAGE_WRAPPER: 'timing-page-wrapper',
    STARTUP_TIME_WRAPPER: 'startup-time-wrapper',
    SHUTDOWN_TIME_WRAPPER: 'shutdown-time-wrapper',
    CUTOFF_TIME_WRAPPER: 'cutoff-time-wrapper',
    BREAK_FREQUENCY_WRAPPER: 'break-frequency-wrapper',
    ANNOUNCEMENT_ID_INPUT: 'announcement-id-input',
    ANNOUNCEMENT_HEADING_INPUT: 'announcement-heading-input',
    ANNOUNCEMENT_DETAILS_INPUT: 'announcement-details-input',
    ANNOUNCEMENT_DETAILS_URL_INPUT: 'announcement-details-url-input',
    ANNOUNCEMENT_EXPIRY_INPUT: 'announcement-expiry-input',
    ANNOUNCEMENT_SUBMIT_BTN: 'announcement-submit-btn',
    ANNOUNCEMENT_RESET_BTN: 'announcement-reset-btn',
    ANNOUNCEMENT_DELETE_BTN: 'announcement-delete-btn'
  }
};
